import * as types from "../mutation-types";

// state
export const state = {
   isSidebarOpen: false
}

// getters
export const getters = {
    isSidebarOpen: state => state.isSidebarOpen,
}

// mutations
export const mutations = {
    [types.CHANGE_SIDEBAR](state)
    {
        state.isSidebarOpen = !state.isSidebarOpen;
    }
}

// actions
export const actions = {
    async changeSidebarStatus({commit})
    {
        commit(types.CHANGE_SIDEBAR)
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/layout.js